<app-community-links [links]="links()" [isVertical]="true" [isLoading]="isLoading()" />
